import './index.css'
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

// Code-splitting resilience: page chunks are hashed, so a browser holding the
// previous index.html fails to fetch a route chunk right after a deploy. Vite
// surfaces that as `vite:preloadError` — reload once to pick up the new
// manifest. The timestamp guard prevents a reload loop when the failure is not
// deployment-related (e.g. offline).
const RELOAD_FLAG = 'oc_chunk_reload_at'
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0)
  if (Date.now() - lastReload < 10_000) return
  event.preventDefault()
  sessionStorage.setItem(RELOAD_FLAG, String(Date.now()))
  window.location.reload()
})

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
